<template>
  <div class="cs-substrate-mount" :class="{ tail: showTail, flat: flat }">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'SubstrateMount',
  props: {
    showTail: {
      type: Boolean,
      default: () => false,
    },
    flat: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>
<style lang="sass" scoped>
  .cs-substrate-mount
    position: relative
    padding: 20px

    +respond-to('small')
      border-radius: 10px

    #{theme('obsidian')} &
      background-color: #181822

    #{theme('eclipse')} &
      background-color: #fff

    > *
      &:not(:last-child)
        margin-bottom: 20px

    &.tail
      &:after
        content: ''
        position: absolute
        left: 50%
        bottom: -50px
        border: 25px solid transparent
        border-top: 25px solid #181823
        transform: translate(-50%)

    &.flat
      > *
        &:not(:last-child)
          margin-bottom: 10px
</style>
